export const NAME = 'inks';